import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SummitUtilService } from '@summit/utils';
import { environment } from '../../environments/environment';
import { ResetPassword } from 'app/models/reset-password.model';
import { RedirectBackURL } from 'app/models/redirect-back-url';

@Injectable()
export class PasswordService {
  constructor(
    private http: HttpClient,
    private summitUtil: SummitUtilService
  ) { }

  public isValidateEmailAddress(email: string): Observable<Boolean> {
    const REST_url: string = environment.authUrl + 'isValidEmailAddress';
    const queryParams: string = '?email=' + email;
    return this.http.get<Boolean>(REST_url + queryParams)
      .pipe(
        catchError(error => {
          const errorMessage = 'Something went wrong when trying to execute: isValidateEmailAddress(email)';
          return this.summitUtil.errorHandlerImpl(error, errorMessage, environment.production);
        })
      );
  }

  public sendResetPasswordLink(loginId: string) {
    const REST_url: string = environment.authUrl + 'sendResetPasswordLink';
    const queryParams: string = '?loginId=' + loginId;
    return this.http.get(REST_url + queryParams)
      .pipe(
        catchError(error => {
          const errorMessage = 'Something went wrong when trying to execute: sendResetPasswordLink(loginId)';
          return this.summitUtil.errorHandlerImpl(error, errorMessage, environment.production);
        })
      );
  }

  public getLoginEmailAddressByPasswordResetUUID(passwordResetUUID: string): Observable<string> {
    const REST_url: string = environment.authUrl + 'getLoginId';
    return this.http.get(REST_url + '?uuid=' + passwordResetUUID, {responseType: 'text'})
      .pipe(
        catchError(error => {
          return 'call-errored';
        })
      );
  }

  public submitNewPassword(resetPasswordBody: ResetPassword): Observable<RedirectBackURL> {
    const AUTH_SERVICES_URL: string = environment.authUrl + 'submitNewPassword';
    return this.http.post<RedirectBackURL>(AUTH_SERVICES_URL, resetPasswordBody)
      .pipe(
        catchError(error => {
          console.log('[FATAL] submitNewPassword() error: '+ error);
          const errorMessage = 'Something went wrong when trying to execute: submitNewPassword(resetPasswordBody)';
          return this.summitUtil.errorHandlerImpl(error, errorMessage, environment.production);
        })
      );
  }
}
